import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BuildCache = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M13.4434 9.0001C12.9706 11.5556 10.7187 13.5 8.00007 13.5C5.64907 13.5 3.64713 12.0459 2.84289 9.99999H1.25665C2.12146 12.8915 4.81331 15 8.00007 15C10.2263 15 12.211 13.971 13.5 12.3649V13H15V9H13.5L13.4434 9.0001Z"
      fill="currentColor"
    />
    <path
      d="M8.00007 2.5C5.28141 2.5 3.02952 4.44444 2.5567 6.99999L1 7V3H2.5V3.63526C3.78901 2.02907 5.77377 1 8.00007 1C11.1869 1 13.8787 3.10856 14.7435 6.0001H13.1573C12.3531 3.95413 10.3511 2.5 8.00007 2.5Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M7.32918 3.83536C7.75147 3.62422 8.24853 3.62422 8.67082 3.83536L11.1708 5.08536C11.679 5.33945 12 5.85884 12 6.427V9.5729C12 10.1411 11.679 10.6605 11.1708 10.9145L8.67082 12.1645C8.24853 12.3757 7.75147 12.3757 7.32918 12.1645L4.82918 10.9145C4.321 10.6605 4 10.1411 4 9.5729V6.427C4 5.85884 4.321 5.33945 4.82918 5.08536L7.32918 3.83536ZM9.98442 6.16921L8 5.177L6.01558 6.16921L8 7.16143L9.98442 6.16921ZM5.5 9.5729L5.5 7.58848L7.25 8.46348V10.4479L5.5 9.5729ZM8.75 10.4479L10.5 9.5729V7.58848L8.75 8.46348V10.4479Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default BuildCache;
